/*
 *
 * OrganizationPage constants
 *
 */
export const TOGGLE_CREATE_MODAL = "app/OrganizationPage/TOGGLE_CREATE_MODAL"
export const CLEAR_TABLE_WATCHER = "app/OrganizationPage/CLEAR_TABLE_WATCHER"
export const CLEAR_TABLE_SUCCEESS = "app/OrganizationPage/CLEAR_TABLE_SUCCEESS"
export const GET_MEDITIONS_ORGANIZATION =
  "app/OrganizationPage/GET_MEDITIONS_ORGANIZATION"
export const GET_MEDITIONS_ORGANIZATION_WATCHER =
  "app/OrganizationPage/GET_MEDITIONS_ORGANIZATION_WATCHER"
export const SUBMIT_FEEDBACK_SURVEY_WATCHER = "app/OrganizationPage/SUBMIT_FEEDBACK_SURVEY_WATCHER"
export const DISMISS_FEEDBACK_SURVEY_WATCHER = "app/OrganizationPage/DISMISS_FEEDBACK_SURVEY_WATCHER"

export const GET_VISMA_PEOPLE_STATUS_WATCHER =  "app/Collaborators/GET_VISMA_PEOPLE_STATUS_WATCHER"
export const GET_VISMA_PEOPLE_STATUS_SUCCESS =  "app/Collaborators/GET_VISMA_PEOPLE_STATUS_SUCCESS"
export const GET_VISMA_PEOPLE_STATUS_FAILED =  "app/Collaborators/GET_VISMA_PEOPLE_STATUS_FAILED"